import React from "react";
import { cn } from "@/lib/utils";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface RadioGroupFieldProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  orientation?: "horizontal" | "vertical";
  className?: string;
}

export function RadioGroupField({
  options,
  value,
  onChange,
  orientation = "vertical",
  className,
}: RadioGroupFieldProps) {
  return (
    <RadioGroup
      value={value || ''}
      onValueChange={onChange}
      className={cn(
        orientation === "horizontal" ? "flex flex-wrap gap-4" : "space-y-2",
        className
      )}
    >
      {options.map((option) => (
        <div key={option} className="flex items-center space-x-2">
          <RadioGroupItem value={option} id={`radio-${option}`} />
          <Label
            htmlFor={`radio-${option}`}
            className="cursor-pointer font-normal"
          >
            {option}
          </Label>
        </div>
      ))}
    </RadioGroup>
  );
}
